import { render, staticRenderFns } from "./RegisterListProject.page.vue?vue&type=template&id=6007bcb0&scoped=true&"
import script from "./RegisterListProject.page.vue?vue&type=script&lang=js&"
export * from "./RegisterListProject.page.vue?vue&type=script&lang=js&"
import style0 from "./RegisterListProject.page.vue?vue&type=style&index=0&id=6007bcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007bcb0",
  null
  
)

export default component.exports